import { UsersService } from "@/clients/services/UsersService";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { syncDeviceTimezone } from "@/utils/timezone/sync-device-timezone";
import { useMutation } from "@tanstack/react-query";

export const useMarkOnboardCompleted = () => {
  const { isPending, error, mutate, mutateAsync } = useMutation({
    mutationFn: () => {
      const user = guardGetUserFromLocalStorage();
      if (!user) {
        throw new Error("User not found");
      }
      return UsersService.markOnboardingCompletedApiV1UsersOnboardingCompletedPatch(user.id);
    },
    onSuccess: () => {
      void syncDeviceTimezone();
    },
  });

  return {
    markOnboardCompleted: mutate,
    markOnboardCompletedAsync: mutateAsync,
    isPending,
    error,
  };
};
